export default __webpack_public_path__ + "static/media/SpringTableImg.3b279421.jpg";